import { create } from 'zustand';
import { registerSessionReset } from '@/stores/session-reset';

export interface NowPlaying {
  trackId: string;
  folderId: string;
  name: string;
  /** Dòng phụ dưới tên bài: «Thư mục · Nhóm». */
  context: string;
}

interface MusicPlayerState {
  current: NowPlaying | null;
  /** Đang THẬT SỰ phát tiếng — khác với «đã chọn bài» (tạm dừng, hết bài, trình duyệt chặn tự phát). */
  playing: boolean;
  /** Tăng mỗi lần bấm ▶: bấm lại chính bài đang nghe thì phát lại từ đầu, như bản cũ. */
  requestId: number;
  play: (track: NowPlaying) => void;
  setPlaying: (playing: boolean) => void;
  close: () => void;
  /** Bài (hoặc cả thư mục chứa nó) vừa bị xoá thì thanh nghe phải đóng theo. */
  closeIfGone: (gone: { trackId?: string; folderId?: string }) => void;
}

/**
 * Bài đang nghe. Nằm NGOÀI màn «Kho nhạc» (thanh nghe gắn ở khung ứng dụng) để sang mục khác làm việc
 * thì nhạc vẫn phát tiếp — bản cũ làm được vì cả app là một trang.
 */
export const useMusicPlayerStore = create<MusicPlayerState>((set, get) => ({
  current: null,
  playing: false,
  requestId: 0,
  play: (track) => set((state) => ({ current: track, requestId: state.requestId + 1 })),
  setPlaying: (playing) => set({ playing }),
  close: () => set({ current: null, playing: false }),
  closeIfGone: ({ trackId, folderId }) => {
    const { current } = get();
    if (current && (current.trackId === trackId || current.folderId === folderId)) get().close();
  },
}));

registerSessionReset(() => useMusicPlayerStore.getState().close());
